module.exports = ".inactive {\n  text-decoration: line-through;\n  opacity: 0.6; }\n\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(2.25rem + 5px); }\n\ntd.delete {\n  cursor: pointer; }\n\ntd.delete.text-muted {\n  cursor: not-allowed; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/schemas/schemas.component.scss
// module id = 578
// module chunks = 1